/**
 * @desc 取消预订舱
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(aono: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinAdvanceMaster/cancel/${aono}`, {
      method: "POST",

      ...options,
    }),
  );
}
